import React from 'react';
import { Box, Card, CardContent, Typography, Button, Alert } from '@mui/material';
import { Schedule, AccountBalanceWallet } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NgeniusReturnPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <Schedule sx={{ fontSize: 64, color: '#064d51', mb: 2 }} />

          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Payment Submitted
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment has been submitted and is being processed.
          </Typography>

          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            Your payment will be verified shortly. Once confirmed, your wallet will be
            updated and you will receive an email notification.
          </Alert>

          <Button
            variant="contained"
            startIcon={<AccountBalanceWallet />}
            onClick={() => navigate('/account/payments')}
            sx={{
              bgcolor: '#064d51',
              '&:hover': { bgcolor: '#053d41' },
            }}
          >
            Go to Payments
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NgeniusReturnPage;
